export async function getDetailOrderReturnedUseCase(order_id, orderReturnedRepository) {

    const result = await orderReturnedRepository.get_detail_order_returned(order_id);
    const order = await new orderReturnedRepository.model(result);

    if (!order.isValid()) {
      throw new Error("order returned is not valid");
    }
  
    return order
}